import { useContext } from 'react';
import {
  SnackBarContext,
  SnackBarProviderProps,
} from 'src/components/SnackBar/SnackBarProvider';

export default function useSnackBar(): SnackBarProviderProps {
  const context = useContext(SnackBarContext);
  /* istanbul ignore if */
  if (!context) {
    throw new Error(
      'SnackBarProviderProps value is undefined. Make sure you use the SnackBarProviderProps before using the context.'
    );
  }
  return context;
}
